import api from './axiosClient'
import { GetCalendarEventsResponse } from '../../proto/generated/calendar-event'

export const getCalendarEvents = async (params: any): Promise<GetCalendarEventsResponse> => {
    return new Promise((resolve, reject) => {
        const url = `/calendar-events`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            params: params,
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const decodedData = GetCalendarEventsResponse.decode(new Uint8Array(response.data))
                resolve(decodedData)
            })
            .catch((error) => {
                reject(error)
            })
    })
}